module.exports = __webpack_public_path__ + "img/logo-irefi-white.04edc973.svg";